// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IPushNotificationsSending } from "models/interfaces";

export const createNotification = createAsyncThunk(
  "push-notification/createNotification",
  async (data: IPushNotificationsSending) => {
    try {
      const response = await REST.post(
        `/push-notification/create-test-push-notification`,
        data
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getPushNotifications = createAsyncThunk(
  "push-notification/getPushNotifications",
  async (page: number) => {
    try {
      const response = await REST.get(
        `/push-notification/get-push-notification?page=${page}&size=50`
      );
      return response;
    } catch (err) {
      return err;
    }
  }
);
